export enum PreCheckoutModal {
  OptionSelection = 'optionSelection',
  ValueProposition = 'valueProposition',
  GenericErrorModal = 'genericErrorModal',
  BumpErrorModal = 'bumpErrorModal',
  None = 'none',
}
